import type { ErrorHandler } from '@angular/core';
import Bugsnag from '@bugsnag/js';

class BugsnagErrorHandler implements ErrorHandler {

    public handleError(error: unknown): void {
        if (Bugsnag.isStarted()) {
            const applicationName = window.location.host.replace(/\.de(?=(:\d+)?$)/, '');

            Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), event => {
                event.context = applicationName;
                event.addMetadata('application', {
                    name: applicationName,
                    url: window.location.href,
                });
            });
        }

        console.error(error);
    }
}

export function bugsnagErrorHandlerFactory(): ErrorHandler {
    return new BugsnagErrorHandler();
}
